// client/src/routes/_auth/unsubscribed.tsx — „/unsubscribed” · D-3043.
//
// The landing of a notification mail's unsubscribe link opened in a browser: the API's `GET
// /api/v1/mail/unsubscribe/{token}` sends the browser here with the token, and the person confirms.
// Under the pathless `_auth` layout for `/verify-email/$token`'s reason — the centred card, the full
// logo and the footer are the frame for a page opened from a mail — and, like it, it redirects
// nobody: the token is the whole authorization, signed in or not.

import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { Unsubscribed } from '@/features/notifications/Unsubscribed';

/** The sealed token, as the API's redirect carries it. A GUID-free opaque string. */
const unsubscribedSearchSchema = z.object({
  token: z.string().trim().max(1024).optional().catch(undefined),
});

export const Route = createFileRoute('/_auth/unsubscribed')({
  validateSearch: unsubscribedSearchSchema,
  component: UnsubscribedScreen,
});

function UnsubscribedScreen() {
  const { token } = Route.useSearch();
  return <Unsubscribed token={token} />;
}
